import { Amplify, Auth } from "aws-amplify";
import { AWS } from "@config/aws";
import { env } from "@/env";

const awsConfig = {
  API: {
    endpoints: [
      {
        custom_header: async () => {
          return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
        },
        endpoint: AWS.api.test.url,
        name: "test",
      },
    ],
  },
  Auth: {
    identityPoolId: AWS.cognito.identityPoolId,
    // mandatorySignIn: true,
    region: AWS.cognito.region,
    // clientId: AWS.cognito.appClientId,
    userPoolId: AWS.cognito.userPoolId,
    userPoolWebClientId: AWS.cognito.appClientId,
    cookieStorage: {
      domain: env.REACT_APP_ENV === 'development' ? 'localhost' : '.b2breservas.com.br',
      path: '/',
      expires: 1,
      secure: true
    }
  },
};

Amplify.configure(awsConfig);
Auth.configure(awsConfig);
